<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleLeft, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, get_current_component, onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zframe from '../_common/z/zframe.svelte'
    import { TagEntity } from '../../modules/eventsApi/tags/tag.entity'
    import type { TagCreateDto } from '../../modules/eventsApi/tags/tags-create.dto'
    import type { TagUpdateDto } from '../../modules/eventsApi/tags/tags-update.dto'
    import Zact from '../_common/z/zact.svelte'
    import { EventTypeEnum } from '../../modules/eventsApi/events/event-type.enum'
    const dispatch = createEventDispatcher()

    const me = get_current_component()

    export let form: boolean = false
    export let tagId: string = null

    let show = false
    let step = 1
    let entities: TagEntity[] = []
    let entity: TagEntity = new TagEntity()

    let ruleAdd = false
    let ruleRemove = false

    onMount(async () => {
        if (form) {
            if (tagId) {
                await editEntity(tagId)
            } else {
                newEntity()
            }
        } else {
            await loadEntities()
        }
    })

    async function loadEntities() {
        try {
            show = true
            entities = []
            entities = await window.api.events.tags.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            entity = new TagEntity()
            entity = await window.api.events.tags.getOne(id)
            if (!entity.eventType) entity.eventType = []
            if (!entity.eventTypeRemove) entity.eventTypeRemove = []
            ruleAdd = entity.eventType?.length > 0
            ruleRemove = entity.eventTypeRemove?.length > 0
            console.log('tag', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new TagEntity()
        ruleAdd = false
        ruleRemove = false
        entity.eventType = []
        entity.eventTypeRemove = []
        step = 2
    }

    async function saveEntity() {
        if (entity.tagId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            show = true
            if (!ruleAdd) entity.eventType = []
            if (!ruleRemove) entity.eventTypeRemove = []
            entity.label = normalizeLabel(entity.label)
            const dto: TagCreateDto = {
                label: entity.label,
                eventContent: entity.eventContent,
                eventType: entity.eventType,
                eventContentRemove: entity.eventContentRemove,
                eventTypeRemove: entity.eventTypeRemove,
            }
            entity = await window.api.events.tags.create(dto)
            tagId = entity.tagId
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            if (!ruleAdd) entity.eventType = []
            if (!ruleRemove) entity.eventTypeRemove = []
            entity.label = normalizeLabel(entity.label)
            const dto: TagUpdateDto = {
                label: entity.label,
                eventContent: entity.eventContent,
                eventType: entity.eventType,
                eventContentRemove: entity.eventContentRemove,
                eventTypeRemove: entity.eventTypeRemove,
            }
            await window.api.events.tags.update(entity.tagId, dto)
            tagId = entity.tagId
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function normalizeLabel(label: string) {
        label = label.toLowerCase()
        label = label.replace(/\s+/g, ' ')
        label = label.replaceAll(' ', '_')
        return label
    }

    function sendClose() {
        dispatch('close')
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.events.tags.remove(entity.tagId)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
        if (form) dispatch('close', {})
    }

    function showTagged(_tagId) {
        tagId = _tagId
        step = 3
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Etiquetas'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Etiqueta' }))
        grid.cols.push(new GridCol({ content: 'Criação', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Atualização', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btnShow = new GridButton({
                callback: () => showTagged(item.tagId),
                label: 'Ver',
            })
            let btnEdit = new GridButton({
                callback: () => editEntity(item.tagId),
                label: 'Editar',
            })

            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.updatedAt })
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
    }
</script>

<Content>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.tags.tags.write}
                <button class="btn btn-secondary" on:click={newEntity}><Fa icon={faPlusCircle} /> Nova etiqueta</button>
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            {#if !form}
                <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            {/if}
            <div class="spacer" />
            {#if !!entity.tagId}
                <button class="btn btn-warning me-1" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Etiqueta" class="h-space">
            <div class="grid-form">
                <div class="row">
                    <div class="col-6">
                        <div class="input-group">
                            <label for="" class="input-group-text">Rótulo da etiqueta</label>
                            <input type="text" bind:value={entity.label} class="form-control" />
                        </div>
                        <div class="text-muted">Espaços serão convertidos em _ e maiúsculas convertidas em minúsculas.</div>
                    </div>
                </div>
            </div>
        </Zframe>

        <Zframe
            title="Atribuição automática de etiqueta"
            headline="Você pode atribuir automaticamente uma etiqueta a uma pessoa caso um evento ocorra."
            class="h-space"
        >
            <div class="grid-form">
                <div class="row">
                    <div class="col mt-1">
                        <div class="form-check form-switch">
                            <input class="form-check-input" bind:checked={ruleAdd} type="checkbox" role="switch" id="entity.users" />
                            <label class="form-check-label" for="entity.users">Ativar</label>
                        </div>
                    </div>
                </div>
                {#if ruleAdd}
                    <div class="row mt-2">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Caso um destes eventos ocorra</label>
                                <select name="evento" id="evento" multiple size="7" bind:value={entity.eventType} class="form-control">
                                    {#each Object.keys(EventTypeEnum) as key, i}
                                        {#if entity.eventType.includes(EventTypeEnum[key])}
                                            <option selected value={key}>{key}</option>
                                        {:else}
                                            <option value={key}>{key}</option>
                                        {/if}
                                    {/each}
                                </select>
                            </div>
                            <div class="form-text text-muted">Utilize CTRL para selecionar mais de um evento.</div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Mas apenas se o evento possuir este conteúdo (opcional)</label>
                                <textarea class="form-control max-height-168" rows="7" bind:value={entity.eventContent} />
                                <div class="form-text text-muted">
                                    Para filtrar vários conteúdos separe por vírgula. Ex.: serviço 1<b>,</b>serviço 2<br />
                                    Para correspondência exata utilize [ ] entre o texto. Ex.: serviço 1<b>,</b><b>[</b>serviço 2<b>]</b><br />
                                    Para que todo os conteúdos sejam obrigatórios coloque entre ( ). Ex.: <b>(</b>serviço 1<b>,</b>serviço 2<b>)</b>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </Zframe>

        <Zframe
            title="Remoção automática de etiqueta"
            headline="Você pode remover automaticamente uma etiqueta de uma pessoa caso um evento ocorra."
            class="h-space"
        >
            <div class="grid-form">
                <div class="row">
                    <div class="col mt-1">
                        <div class="form-check form-switch">
                            <input class="form-check-input" bind:checked={ruleRemove} type="checkbox" role="switch" id="entity.users" />
                            <label class="form-check-label" for="entity.users">Ativar</label>
                        </div>
                    </div>
                </div>
                {#if ruleRemove}
                    <div class="row mt-2">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Caso um destes eventos ocorra</label>
                                <select name="evento" id="evento" multiple size="7" bind:value={entity.eventTypeRemove} class="form-control">
                                    {#each Object.keys(EventTypeEnum) as key, i}
                                        {#if entity.eventTypeRemove.includes(EventTypeEnum[key])}
                                            <option selected value={key}>{key}</option>
                                        {:else}
                                            <option value={key}>{key}</option>
                                        {/if}
                                    {/each}
                                </select>
                            </div>
                            <div class="form-text text-muted">Utilize CTRL para selecionar mais de um evento.</div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Mas apenas se o evento possuir este conteúdo (opcional)</label>
                                <textarea class="form-control max-height-168" rows="7" bind:value={entity.eventContentRemove} />
                                <div class="form-text text-muted">
                                    Para filtrar vários conteúdos separe por vírgula. Ex.: serviço 1<b>,</b>serviço 2<br />
                                    Para correspondência exata utilize [ ] entre o texto. Ex.: serviço 1<b>,</b><b>[</b>serviço 2<b>]</b><br />
                                    Para que todo os conteúdos sejam obrigatórios coloque entre ( ). Ex.: <b>(</b>serviço 1<b>,</b>serviço 2<b>)</b>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </Zframe>
    {/if}
    {#if step === 3}
        <!-- <AudienceShow on:close={showEntities} {audienceId} /> -->
    {/if}
</Content>
<LoadSpinner {show} />

<style>
    .grid-form > .row > div {
        margin-top: 0px;
    }
    .max-height-168 {
        max-height: 168px;
    }
</style>
